import React from 'react'
import { Tooltip } from '@mui/material'
import i18n from '../../simple-react-i18n'
import SmsIcon from '@mui/icons-material/Sms'
import { usedUrl } from '../../conf/basepath'

const ShowCmsLog = () => {
    return (
        <Tooltip title={i18n.logsMessage} placement='bottom'>
            <SmsIcon
                sx={{ fontSize: '3rem', width: '69px', height: '50px', paddingTop: '12px', cursor: 'pointer' }}
                onClick={() => window.open(`${usedUrl}#/administration/cms`, '_blank')}
            />
        </Tooltip>
    )
}

export default ShowCmsLog